import Axios from "../utils/axiosInstance";
import fileSaver from "file-saver";
//  here add petrotec pre for each url whenever need
// API for creating user entry
// export const postUserEntry = (payload) => {
//   return Axios.post(`/createUser`, payload);
// };

// New user register api for microservice
export const postUserEntry = (payload) => {
  return Axios.post(`/auth/register`, payload);
};

// API for updating user details
export const putUserEntry = (payload) => {
  let token = sessionStorage.getItem("token");
  return Axios.put(`/User/updateUserDetails`, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

// // API for getting list of all user
// export const getUserEntry = (pageNo, fkUserId, role, headers) => {
//   return Axios.get(`/User/getUserList/${pageNo}?&fkUserId=${fkUserId}&role=${role}`, {
//       headers,
//     }
//   );
// };

// API for getting list of all user
export const getUserEntry = (pageNo, fkUserId, role, headers) => {
   let token = sessionStorage.getItem("token");
  return Axios.get(`/User/getUserList/${pageNo}?&fkUserId=${fkUserId}&role=${role}`, {
     headers: { Authorization: `Bearer ${token}` },
    }
  );
};

// API for getting list of all user by from and to date
export const getUserEntryByDate = (pageNo, fromDate, toDate) => {
  let token = sessionStorage.getItem("token");
  return Axios.get(
    `/User/getUserDetailsBetWeenTwoDates/${pageNo}?fromDate=${fromDate}&toDate=${toDate}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};

export const getUserEntryPdfDownload = (fromDate, toDate) => {
  let fileType = ["Pdf"];
  let token = sessionStorage.getItem("token");
  return Axios.get(
    `/User/getUserReportExcelPDFCSV?fileType=${fileType}&fromDate=${fromDate}&toDate=${toDate}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "arraybuffer",
    }
  ).then((response) => {
    var blob = new Blob([response.data], { type: "application/pdf" });
    fileSaver.saveAs(blob, `userreport.pdf`);
  });
};

export const getUserEntryExcelDownload = (fromDate, toDate) => {
  let fileType = ["Excel"];
  let token = sessionStorage.getItem("token");
  return Axios.get(
    `/User/getUserReportExcelPDFCSV?fileType=${fileType}&fromDate=${fromDate}&toDate=${toDate}`,
    {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "arraybuffer",
    }
  ).then((result) => {
    let blob = new Blob([result.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    fileSaver.saveAs(blob, "userreport.xlsx");
  });
};

// API for getting list of all user for Drop Down
export const getUserEntryforDropDown = (headers) => {
  return Axios.get(`/User/getServiceEngineerDropDown`, {
    headers,
  });
};

export const getUserLExcel = (fileType, headers) => {
  // let fkUserId = sessionStorage.getItem("pkUserId");
  // let role = sessionStorage.getItem("role");
  // let token = sessionStorage.getItem("token");
  // let fileType = ["Excel"];
  return Axios.get(`/User/getUserListExcel?fileType=${fileType}`, {
    headers,
    responseType: "arraybuffer",
  });
  // .then((response) => {
  //   var blob = new Blob([response.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
  //   fileSaver.saveAs(blob, "userList.xlsx");
  // });
};

// API for getting employee user list against role:
// Endpoint: https://petropulse-test.petrotec.com/User/employeuserlistagainstrole or /User/getdestDetails?role=Employee&fkUserId=163ad82d-9f74-4745-bc7c-223ca13fc33
export const getEmployeeUserListAgainstRole = async (role = "Employee", fkUserId, headers) => {
  let token = sessionStorage.getItem("token") || localStorage.getItem("token");
  let queryRole = role || "Employee";
  let sessionUserId = sessionStorage.getItem("pkUserId") || localStorage.getItem("pkUserId");
  let queryUserId =
    fkUserId !== undefined && fkUserId !== null && String(fkUserId).trim() !== ""
      ? fkUserId
      : (sessionUserId || "163ad82d-9f74-4745-bc7c-223ca13fc33");

  const authHeaders = headers || (token ? { Authorization: token.startsWith("Bearer ") ? token : `Bearer ${token}` } : {});

  try {
    const res = await Axios.get("/User/employeuserlistagainstrole", {
      params: { role: queryRole, fkUserId: queryUserId },
      headers: authHeaders,
    });
    if (res && res.data) return res;
  } catch (err) {
    console.warn("getEmployeeUserListAgainstRole (/User/employeuserlistagainstrole) failed:", err?.message || err);
  }

  try {
    const res = await Axios.get("/User/employeuserlistagainstrole", {
      params: { role: queryRole },
      headers: authHeaders,
    });
    if (res && res.data) return res;
  } catch (err) {
    // continue to fallback
  }

  return Axios.get("/User/getdestDetails", {
    params: { role: queryRole, fkUserId: queryUserId },
    headers: authHeaders,
  });
};

export const employeuserlistagainstrole = getEmployeeUserListAgainstRole;
export const getemployeuserlistagainstrole = getEmployeeUserListAgainstRole;
